import React from "react"
import Layout from "../components/layout"
import vinnarar2026 from "../../static/img/2026_vinnarar_2.jpg"

export default () => (
    <Layout>
        <img src={vinnarar2026} alt="Vinnarar 2026"/>
        <h1>Kiwanis stuðlar børnum umvegis millum annað jólatræssølu og lutaseðlasølu á Ólavsøku</h1>        
        <h4>Tað eru 3. Kiwanis felagsskapir í Føroyum.</h4>
        <p>Kiwanis Tórshavn og Kiwanis Rósan í Havn, og Kiwanis Eysturoy, sum hevur heimstað í Gøtu. 
        <blockquote>Orðið “kiwanis” stavar úr indianskum máli og merkir “vit byggja.”</blockquote>
        <b>Nevndin í Kiwanis Tórshavn</b>
        </p>
    </Layout>
) 
